import { Add as AddIcon } from '@mui/icons-material';
import { Stack, useTheme } from "@mui/material";
import { alpha } from '@mui/material/styles';

interface AddTodoOverlayProps {
    onClick: () => void;
}

export const AddTodoOverlay: React.FC<AddTodoOverlayProps> = ({ onClick }) => {
    const theme = useTheme();

    return (
        <Stack
            width="calc(100% - 4px)"
            height="calc(100% - 4px)"
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            alignItems="center"
            justifyContent="center"
            onClick={onClick}
            sx={{
                cursor: 'pointer',
                border: '2px dashed',
                borderColor: alpha(theme.palette.grey[500], 0.1),
                bgcolor: alpha(theme.palette.grey[700], .2),
                transition: 'all 0.2s ease',
                inset: 0,
                margin: 0,
                '&:hover': {
                    borderColor: alpha(theme.palette.primary.light, 0.5),
                    bgcolor: alpha(theme.palette.grey[700], 0.4),
                },
            }}
        >
            <AddIcon
                fontSize="large"
                sx={{ color: theme.palette.primary.contrastText }}
            />
        </Stack>
    );
}; 